var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`width:${_vm.width}px; height:${_vm.height}px; bottom:${_vm.bottom}; left:${_vm.leftPos}; top:${_vm.topPos}; right:${_vm.right}; position:fixed; cursor:grabbing; z-index: 1032; touch-action: none; `),attrs:{"id":_vm.id,"draggable":"false"},on:{"click":_vm.removeDrag}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }